<template>
<div>



  <v-layout d-flex>
  <v-card>
    <v-toolbar height="42" flat>
      <v-toolbar-title>
  <v-icon color="#4A76A8" left>mdi-script</v-icon>  Скрипты
      </v-toolbar-title>
   <v-spacer></v-spacer>

   <v-btn @click="addScriptModal = !addScriptModal" color="#4A76A8"   flat small> <v-icon left>mdi-plus</v-icon>  Добавить скрипт</v-btn>
    </v-toolbar>
  <v-card-text>



<div v-for="item of skList"
style="margin-bottom:25px"
>
  <v-toolbar flat>
      <v-toolbar-title>
        {{item.name}}
      </v-toolbar-title>
  <v-spacer/>
 <v-icon @click="redact(item)" style="margin:5px">mdi-lead-pencil</v-icon>
 <v-icon @click="deleteSk(item.id)" style="margin:5px">mdi-close</v-icon>

  </v-toolbar>

</div>



  </v-card-text>


  </v-card>

  </v-layout>






<v-dialog width="900" v-model="addScriptModal">
<v-toolbar color="#4A76A8" height="42">
<v-toolbar-title style="color:white">
Регистрация нового скрипта
</v-toolbar-title>
<v-spacer/>
<v-icon @click="addScriptModal = !addScriptModal" color="white">mdi-close</v-icon>
</v-toolbar>
<v-card>
<v-card-text>

<v-text-field
v-model="name"
label="Название скрипта"
/>

<v-text-field
v-model="path"
label="Путь к скрипту"
/>


<v-textarea
v-model="store"
label="Произвольная информация"
/>








</v-card-text>
<v-card-actions>
  <v-spacer/>
<v-btn @click="addSk()" class="white--text" color="#4A76A8" small>  <v-icon>mdi-plus</v-icon>  Добавить скрипт</v-btn>
</v-card-actions>
</v-card>
</v-dialog>























<v-dialog width="900" v-model="redactScriptModal">
<v-toolbar color="#4A76A8" height="42">
<v-toolbar-title style="color:white">
Редактировать информацию о скрипте
</v-toolbar-title>
<v-spacer/>
<v-icon @click="redactScriptModal = !redactScriptModal" color="white">mdi-close</v-icon>
</v-toolbar>
<v-card>
<v-card-text>

<v-text-field
v-model="redactItem.name"
label="Название скрипта"
/>

<v-text-field
v-model="redactItem.path"
label="Путь к скрипту"
/>


<v-textarea
v-model="redactItem.store"
label="Произвольная информация"
/>








</v-card-text>
<v-card-actions>
  <v-spacer/>
<v-btn flat @click="redactScriptModal=!redactScriptModal" color="#4A76A8" small>  <v-icon left>mdi-close</v-icon>  Закрыть</v-btn>
<v-btn @click="redactConfirm()" class="white--text" color="#4A76A8" small>  <v-icon left>mdi-lead-pencil</v-icon>  Редактировать скрипт</v-btn>
</v-card-actions>
</v-card>
</v-dialog>














</div>
</template>




<script>
import axios from 'axios'
import info from './info.vue'
export default {
components:{info},
 data: function(){
  return {
skList: [],

redactItem: {
  id:'',
  name: '',
  path: '',
  store: '',
},

redactScriptModal: false,
addScriptModal: false,
name: '',
path: '',
store: '',

}
},

methods:{


redact(item){
  this.redactScriptModal = true

  this.redactItem.id = item.id
  this.redactItem.name = item.name
  this.redactItem.path = item.path
  this.redactItem.store = item.store
},


redactConfirm(){
    axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/scripts/redact.php', {
         method: 'POST',
         data: {
           id: this.redactItem.id,
           name : this.redactItem.name,
           path: this.redactItem.path,
           store: this.redactItem.store,
         }
       })
       .then( response => {
         this.skList  = response.data
         this.redactScriptModal = false
       })

},










addSk(){
    axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/scripts/add.php', {
         method: 'POST',
         data: {
           name : this.name,
           path: this.path,
           store: this.store,
         }
       })
       .then( response => {
         this.skList  = response.data
         this.addScriptModal  =  false
         //console.log(response.data)
       })
},

deleteSk(id){
    axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/scripts/delete.php', {
         method: 'POST',
         data: {
           id : id
         }
       })
       .then( response => {
         this.skList  = response.data
       })
},





},

mounted (){
    axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/scripts/get_list.php', {
         method: 'POST',
         data: {
           data: null
         }
       })
       .then( response => {
         this.skList  = response.data
         //this.addScriptModal  =  false
         //console.log(response.data)
       })
},

}
</script>

<style>
 .row-selected {
   background-color: red
 }
</style>
